(function () {
  'use strict';

  /* ── Slider ─────────────────────────────────────────────── */
  function initSlider(gallery) {
    var inner  = gallery.querySelector('.jp2-slider-inner');
    var slides = gallery.querySelectorAll('.jp2-slide');
    var dots   = gallery.querySelectorAll('.jp2-dot');
    var thumbs = gallery.querySelectorAll('.jp2-thumb');

    if (!inner || slides.length <= 1) return;

    var current   = 0;
    var startX    = 0;
    var dragDelta = 0;
    var dragging  = false;

    function goTo(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      current = index;
      inner.style.transform = 'translateX(-' + (index * 100) + '%)';

      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
        if (i === index) {
          t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }
      });
    }

    /* Dot clicks */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index, 10));
      });
    });

    /* Thumbnail clicks */
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(thumb.dataset.index, 10));
      });
    });

    /* Touch swipe */
    inner.addEventListener('touchstart', function (e) {
      startX    = e.touches[0].clientX;
      dragDelta = 0;
      dragging  = true;
    }, { passive: true });

    inner.addEventListener('touchmove', function (e) {
      if (dragging) dragDelta = e.touches[0].clientX - startX;
    }, { passive: true });

    inner.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      if (dragDelta < -50)      goTo(current + 1);
      else if (dragDelta > 50)  goTo(current - 1);
    });

    /* Mouse drag */
    inner.addEventListener('mousedown', function (e) {
      startX    = e.clientX;
      dragDelta = 0;
      dragging  = true;
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      if (dragging) dragDelta = e.clientX - startX;
    });

    document.addEventListener('mouseup', function () {
      if (!dragging) return;
      dragging = false;
      if (dragDelta < -50)      goTo(current + 1);
      else if (dragDelta > 50)  goTo(current - 1);
    });

    /* Keyboard */
    gallery.setAttribute('tabindex', '0');
    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });

    goTo(0);
  }

  /* ── Popups ─────────────────────────────────────────────── */
  function initPopups() {
    var lastFocused = null;

    function openPopup(id) {
      var overlay = document.getElementById(id);
      if (!overlay) return;
      lastFocused = document.activeElement;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var closeBtn = overlay.querySelector('.jp2-popup-close');
      if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
    }

    function closePopup(overlay) {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocused) lastFocused.focus();
    }

    document.querySelectorAll('[data-jp2-popup]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openPopup(trigger.dataset.jp2Popup);
      });
    });

    document.querySelectorAll('.jp2-popup-overlay').forEach(function (overlay) {
      var closeBtn = overlay.querySelector('.jp2-popup-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () { closePopup(overlay); });
      }
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closePopup(overlay);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.jp2-popup-overlay.is-open').forEach(function (ov) {
          closePopup(ov);
        });
      }
    });
  }

  /* ── Buy Now ────────────────────────────────────────────── */
  function initBuyNow() {
    document.querySelectorAll('.jp2-buy-now').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        /* Resolve current variant ID */
        var variantId = null;

        /* 1. Try the variant picker's JSON script tag (most reliable) */
        var variantScript = document.querySelector('[data-selected-variant]');
        if (variantScript) {
          try {
            var variant = JSON.parse(variantScript.textContent);
            if (variant) variantId = variant.id;
          } catch (_) {}
        }

        /* 2. Fallback: read the hidden form input */
        if (!variantId) {
          var hiddenInput = document.querySelector('[data-type="add-to-cart-form"] input[name="id"]');
          if (hiddenInput) variantId = hiddenInput.value;
        }

        if (!variantId) return;

        var originalText   = btn.textContent;
        btn.textContent    = 'Processing…';
        btn.disabled       = true;

        fetch('/cart/add.js', {
          method:  'POST',
          headers: {
            'Content-Type':    'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function () {
            btn.textContent = originalText;
            btn.disabled    = false;
          });
      });
    });
  }

  /* ── Bootstrap ──────────────────────────────────────────── */
  function init() {
    document.querySelectorAll('.jp2-gallery').forEach(initSlider);
    initPopups();
    initBuyNow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init when Theme Editor reloads the section */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.jp2-gallery').forEach(initSlider);
    initPopups();
    initBuyNow();
  });
})();
